import { Theme } from '@mui/material/styles';
import { GridLocaleText } from '@mui/x-data-grid';

// Objeto de tradução para o DataGrid
export const ptBRGridLocale: Partial<GridLocaleText> = {
  // Root
  noRowsLabel: 'Nenhum registro encontrado',
  noResultsOverlayLabel: 'Nenhum resultado encontrado.',

  // Density selector toolbar button text
  toolbarDensity: 'Densidade',
  toolbarDensityLabel: 'Densidade',
  toolbarDensityCompact: 'Compacto',
  toolbarDensityStandard: 'Padrão',
  toolbarDensityComfortable: 'Confortável',

  // Columns selector toolbar button text
  toolbarColumns: 'Colunas',
  toolbarColumnsLabel: 'Exibir seletor de colunas',

  // Filters toolbar button text
  toolbarFilters: 'Filtros',
  toolbarFiltersLabel: 'Exibir filtros',
  toolbarFiltersTooltipHide: 'Ocultar filtros',
  toolbarFiltersTooltipShow: 'Exibir filtros',
  toolbarFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} filtros ativos` : `${count} filtro ativo`,

  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: 'Pesquisar…',
  toolbarQuickFilterLabel: 'Pesquisar',
  toolbarQuickFilterDeleteIconLabel: 'Limpar',

  // Export selector toolbar button text
  toolbarExport: 'Exportar',
  toolbarExportLabel: 'Exportar',
  toolbarExportCSV: 'Baixar como CSV',
  toolbarExportPrint: 'Imprimir',

  // Columns panel text
  columnsPanelTextFieldLabel: 'Localizar coluna',
  columnsPanelTextFieldPlaceholder: 'Título da coluna',
  columnsPanelDragIconLabel: 'Reordenar coluna',
  columnsPanelShowAllButton: 'Mostrar todas',
  columnsPanelHideAllButton: 'Ocultar todas',

  // Filter panel text
  filterPanelAddFilter: 'Adicionar filtro',
  filterPanelDeleteIconLabel: 'Excluir',
  filterPanelOperators: 'Operadores',
  filterPanelOperatorAnd: 'E',
  filterPanelOperatorOr: 'Ou',
  filterPanelColumns: 'Colunas',
  filterPanelInputLabel: 'Valor',
  filterPanelInputPlaceholder: 'Filtrar valor',

  // Filter operators text
  filterOperatorContains: 'contém',
  filterOperatorEquals: 'igual a',
  filterOperatorStartsWith: 'começa com',
  filterOperatorEndsWith: 'termina com',
  filterOperatorIs: 'é',
  filterOperatorNot: 'não é',
  filterOperatorAfter: 'depois de',
  filterOperatorOnOrAfter: 'em ou depois de',
  filterOperatorBefore: 'antes de',
  filterOperatorOnOrBefore: 'em ou antes de',
  filterOperatorIsEmpty: 'está vazio',
  filterOperatorIsNotEmpty: 'não está vazio',

  // Filter values text
  filterValueAny: 'qualquer',
  filterValueTrue: 'verdadeiro',
  filterValueFalse: 'falso',

  // Column menu text
  columnMenuLabel: 'Menu',
  columnMenuShowColumns: 'Exibir colunas',
  columnMenuFilter: 'Filtrar',
  columnMenuHideColumn: 'Ocultar',
  columnMenuUnsort: 'Desfazer ordenação',
  columnMenuSortAsc: 'Ordenar ASC',
  columnMenuSortDesc: 'Ordenar DESC',

  // Column header text
  columnHeaderFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} filtros ativos` : `${count} filtro ativo`,
  columnHeaderFiltersLabel: 'Exibir filtros',
  columnHeaderSortIconLabel: 'Ordenar',

  // Rows selected footer text
  footerRowSelected: (count) =>
    count !== 1
      ? `${count.toLocaleString()} registros selecionados`
      : `${count.toLocaleString()} registro selecionado`,

  // Total rows footer text
  footerTotalRows: 'Total de registros:',

  // Total visible rows footer text
  footerTotalVisibleRows: (visibleCount, totalCount) =>
    `${visibleCount.toLocaleString()} de ${totalCount.toLocaleString()}`,

  // Pagination text
  MuiTablePagination: {
    labelDisplayedRows: ({ from, to, count }) =>
      `${from}–${to} de ${count !== -1 ? count : `mais de ${to}`}`,
    labelRowsPerPage: 'Linhas por página:',
  },
};

// Estilos compartilhados para o DataGrid
export const getDataGridStyles = (theme: Theme) => ({
  border: 'none',
  minHeight: 400,
  '& .MuiDataGrid-columnHeaders': { 
    backgroundColor: theme.palette.grey[100],
    height: 36,
    fontSize: '0.85rem',
    fontWeight: 'bold'
  },
  '& .MuiDataGrid-cell': {
    fontSize: '0.85rem',
    py: 0.5
  },
  '& .MuiDataGrid-footerContainer': { 
    borderTop: `1px solid ${theme.palette.divider}`,
    height: 36,
    fontSize: '0.8rem'
  },
  '& .MuiTablePagination-root': {
    fontSize: '0.8rem'
  },
  '& .MuiTablePagination-displayedRows': {
    fontSize: '0.8rem'
  },
  '& .MuiTablePagination-selectLabel': {
    fontSize: '0.8rem'
  },
  '& .MuiTablePagination-select': {
    fontSize: '0.8rem',
    p: 0
  },
  '& .MuiTablePagination-menuItem': {
    fontSize: '0.8rem',
    py: 0.75,
    px: 2,
    display: 'flex',
    justifyContent: 'center'
  },
  '& .MuiSelect-select': {
    paddingY: 0.5,
    minWidth: '1.5rem',
    textAlign: 'center',
    backgroundColor: theme.palette.grey[50]
  },
  '& .MuiDataGrid-overlay': {
    fontSize: '0.8rem'
  }
}); 